import { React, useContext, useRef, useState } from "react";
import { PageContext } from "../../App";
import { appListItems } from "./AppList";

function ExploreAppsSearchBar() {
  //get context
  const { setAppListShowing } = useContext(PageContext);
  //search bar value
  const [searchValue, setSearchValue] = useState("");
  //ref
  const searchInput = useRef(null);

  return (
    <div className="container">
      {/* Content */}
      <div className="d-flex text-center mt-5 justify-content-center align-items-center">
        {/* Search icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-search me-2"
          viewBox="0 0 16 16"
        >
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
        </svg>
        {/* Search input */}
        <input
          className="form-control border-info rounded-3 "
          style={{ width: "90%" }}
          id="seatrch_apps_name"
          value={searchValue}
          ref={searchInput}
          placeholder="Enter app name to search... (pdf compressor, pdf merger, pdf splitter etc)"
          onChange={(e) => {
            //set search value
            setSearchValue(e.target.value);
            //update list
            const newArr = appListItems.filter((val) =>
              e.target.value === ""
                ? true
                : val.name
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase()) ||
                  val.subtitle
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase()),
            );

            //set array
            setAppListShowing(newArr);
          }}
        />

        {/* cross button */}
        <button
          className={`btn btn-clear fs-6 text-danger ${searchValue === "" ? "d-none" : ""}`}
          style={{ height: "40px" }}
          onClick={(e) => {
            //set value
            setSearchValue("");
            //set
            setAppListShowing(appListItems);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-x-circle"
            viewBox="0 0 16 16"
          >
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default ExploreAppsSearchBar;
